export enum DecisionType {
    ACCEPT_MY_CHOICE = 'ACCEPT_MY_CHOICE',
    ACCEPT_ALL = 'ACCEPT_ALL',
    DECLINE_ALL = 'DECLINE_ALL',
}